import React from 'react';
import About from '../About/About';
import ContactForm from '../ContactForm/ContactForm';
import Projects from '../MyProjects/Projects';

import Data from './Data';
import "./Home.css"
import ScrollDown from './ScrollDown';
import Social from './Social';

const Home = () => {
    return (
        <section className='home section' id='home'>
            <div className='home__container container grid'>
                <div className='home__content grid'>
                    <Social></Social>
                    <div className='home__image'> </div>
                    <Data></Data>
                </div>
                <ScrollDown></ScrollDown>
                <About></About>
                <Projects></Projects>
                <ContactForm></ContactForm>
            </div>
        </section>
    );
};

export default Home;